import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { getTrafficStatusData } from '../../features/publicDataSlice';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { MainLayout } from '../../layouts';
import { DateTimePicker, TabPanel } from './components';
import { isEmpty } from '../../utils/functions';
import { enqueueSnackbar } from '../../features/notificationSlice';
import {
  Map,
  PositionChoose,
} from '../Shared';
import {
  StyledHeader,
  StyledListItem,
  StyledButton,
} from './PublicData.styled';

const PublicData = (props) => {
  const [positionChoose, setPositionChoose] = useState('rectangle');
  const [mapDataPosition, setMapDataPosition] = useState([]);
  const [isDisplayResponse, setIsDisplayResponse] = useState(false);
  const [timeData, setTimeData] = useState({});
  const [radius, setRadius] = useState(300);
  const [option, setOption] = useState(0);
  const [radiusError] = useState('');
  const [isDisplayTrafficStatus, setIsDisplayTrafficStatus] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleGetData = (e) => {
    if (mapDataPosition.length > 0 && !isEmpty(timeData)) {
      setIsDisplayResponse(true);
      const time = {
        start: new Date(timeData.startTime).toISOString(),
        end: new Date(timeData.endTime).toISOString(),
      };
      let payload = {
        type: positionChoose,
        time,
        coordinates: mapDataPosition,
      };
      if (positionChoose === 'circle') {
        if (radiusError) {
          setIsDisplayResponse(false);
          dispatch(
            enqueueSnackbar({
              message: t('ErrorNotChoosePosition'),
              options: {
                variant: 'error',
              },
            })
          );
          return;
        }
        payload = {
          ...payload,
          radius: radius,
        };
      } else if (positionChoose === 'line') {
        payload = {
          ...payload,
          option: option,
        };
      }
      dispatch(getTrafficStatusData(payload));
      return;
    } else if (mapDataPosition.length <= 0) {
      setIsDisplayResponse(false);
      dispatch(
        enqueueSnackbar({
          message: t('ErrorNotChoosePosition'),
          options: {
            variant: 'error',
          },
        })
      );
    } else {
      setIsDisplayResponse(false);

      dispatch(
        enqueueSnackbar({
          message: t('ErrorNotChooseTime'),
          options: {
            variant: 'error',
          },
        })
      );
    }
  };
  const instruction = () => {
    if (positionChoose === 'rectangle') {
      return <span>{t('RectangleInstruction')}</span>;
    } else if (positionChoose === 'circle') {
      return <span>{t('CircleInstruction')}</span>;
    } else {
      return <span>{t('LineInstruction')}</span>;
    }
  };
  return (
    <MainLayout>
      <Grid container direction='row' justify='center'>
        <Grid item xs={12} style={{ maxWidth: 800 }}>
          <StyledHeader>{t('PublicDataHeader')}</StyledHeader>
          <Grid container direction='row' justify='center' alignItems='center'>
            <h4 style={{ marginRight: 16 }}>{t('ChangeModeLabel')}</h4>
            <Button
              variant='contained'
              color='primary'
              onClick={() => {
                setIsDisplayTrafficStatus(!isDisplayTrafficStatus);
              }}
            >
              {!isDisplayTrafficStatus
                ? t('ViewTrafficStatusButton')
                : t('GetTrafficStatusButton')}
            </Button>
          </Grid>
          {!isDisplayTrafficStatus ? (
            <p>{t('ViewTrafficStatusTutorial')}</p>
          ) : (
            <p>{t('GetTrafficStatusTutorial')}</p>
          )}
          <h4>{t('InstructionHeader')}</h4>
          <ol style={{ marginBottom: 0, paddingBottom: 16 }}>
            <li>{t('InstructionPosition')}</li>
            <PositionChoose
              positionChoose={positionChoose}
              setPositionChoose={setPositionChoose}
              isDisabled={isDisplayTrafficStatus}
            />
            <p>
              <strong>{t('InstructionTitle')} </strong>
              {instruction()}
            </p>
            <Map
              setMapDataPosition={setMapDataPosition}
              positionChoose={positionChoose}
              radius={
                !radiusError && positionChoose === 'circle' ? radius : null
              }
              setRadius={setRadius}
              setOption={setOption}
              isDisplayTrafficStatus={isDisplayTrafficStatus}
            />
            <StyledListItem>{t('DateTimePicker')}</StyledListItem>
            <DateTimePicker
              setTimeData={setTimeData}
              labelTitle={{ from: t('LabelFromTitle'), to: t('LabelToTitle') }}
              labelSelect={{
                date: t('LabelDateSelect'),
                time: t('LabelTimeSelect'),
              }}
              isDisabled={isDisplayTrafficStatus}
            />
            <StyledButton
              variant='contained'
              color='primary'
              className='buttonGetData'
              onClick={handleGetData}
              disabled={isDisplayTrafficStatus}
            >
              {t('GetDataButton')}
            </StyledButton>
            <StyledListItem>{t('PublicDataResultHeader')} </StyledListItem>
            {isDisplayResponse ? (
              <TabPanel />
            ) : (
              <strong>{t('PublicDataResult')}</strong>
            )}
          </ol>
        </Grid>
      </Grid>
    </MainLayout>
  );
};

export default PublicData;
